export default __webpack_public_path__ + "static/media/logo_fluidit.44b64894.svg";